import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ProductSkeletonListContainer = Box.withConfig({
  width: 'full',
  backgroundColor: primitive.$white,
  alignItems: 'center',
});

export const ProductSkeletonListItems = Box.withConfig({
  width: 'full',
  flexDirection: 'column',
  marginTop: '$2',
});

export const ListItem = Box.withConfig({
  width: 'full',
  height: 90,
  padding: '$4',
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity10,
});

export const SkeletonListItem = Box.withConfig({
  flexDirection: 'row',
});
